<div class="row">
  <div class="col-10 col-sm-10">
    <h1 mat-dialog-title>User Profile</h1>
  </div>
  <div class="col-2 col-sm-2 text-right">
    <button mat-icon-button [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div mat-dialog-content>
  <div class="row">
    <mat-card class="col-sm-3">
      <img mat-card-image [src]="profile_photo">
      <div class="row" fxLayoutAlign="center center">
        <h4><b>{{userData?.firstName}} {{userData?.lastName}}</b></h4>
      </div>
      <div class="row" fxLayoutAlign="center center" *ngIf="isClient">
        <button matTooltip="New Retail Store Registraion URL" mat-raised-button color="warn" (click)="onClickURLCopy()">
          <mat-icon >link</mat-icon> Copy URL
        </button>      
      </div>
      <br>
      <mat-divider></mat-divider>
      <!-- <br>
      <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!currentUserData.delegateAccess && currentUserData.userType.includes('RSTO')">
        <h4><b>Upgrade to Business User</b></h4>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!currentUserData.delegateAccess && currentUserData.userType.includes('RSTO')">
      <button (click)="onClickUpgrade()">Upgrade</button>
      </div>
      <br>
      <mat-divider></mat-divider> -->
      <br>
      <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!currentUserData.delegateAccess">
        <h4><b>Scanfluence ID</b></h4>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!currentUserData.delegateAccess">
        <h4>{{userData?.email}}</h4>
      </div>
      <br>

      <mat-divider></mat-divider>
      <br>
      <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!currentUserData.delegateAccess">
        <h4><b>Join Date</b></h4>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!currentUserData.delegateAccess">
        <h4>{{userData?.created | date: 'MMM dd yyyy'}}</h4>
      </div>
      <br>
      <mat-divider></mat-divider>
      <br>
    </mat-card>
    <mat-card class="col-sm-9">
      <mat-tab-group [ngClass]="'tab-body-content'">
        <mat-tab label="{{!currentUserData.delegateAccess ? 'Edit Profile' : currentUserData.userType.includes('ORGA') ? 'QR Code' : 'Profile'}}">
          <app-edit-profile class="tab-body-content"
            (valueChangeEditProfile)="valueChangeEditProfile()"></app-edit-profile>
        </mat-tab>

        <mat-tab label="Password" *ngIf="!currentUserData.delegateAccess">
          <app-change-password class="tab-body-content"></app-change-password>
        </mat-tab>
        
        <mat-tab label="Integration Profile" *ngIf="!currentUserData.delegateAccess">
          <app-integration class="tab-body-content"></app-integration>
        </mat-tab>

            <mat-tab label="Links" *ngIf="!currentUserData.delegateAccess">
          <app-media-links class="tab-body-content"></app-media-links>
        </mat-tab>
        <!-- <mat-tab label="User Licences">
          <app-assigned-licences></app-assigned-licences>
        </mat-tab>

        <mat-tab label="Subsciptions">
          <app-subscription></app-subscription>
        </mat-tab> -->
      </mat-tab-group>
    </mat-card>
  </div>
</div>